<template>
  <vx-card no-shadow :style="{ 'pointer-events': __isDisabledSites() ? 'none' : 'auto' }">

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_health_policy" name="is_health_policy" rules="" v-slot="{ errors }">
              <small class="label">12.1 Do you have a Health and Safety Policy? If yes, has it been issued to all staff? </small>
              <vs-switch v-model="form.is_health_policy" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_health_policy" vid="is_health_policy_text" name="is_health_policy_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_health_policy_text" class="w-full" v-model="form.is_health_policy_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_trained_aiders" name="is_trained_aiders" rules="" v-slot="{ errors }">
              <small class="label">12.2 Do you have trained first aiders on site?</small>
              <vs-switch v-model="form.is_trained_aiders" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_trained_aiders" vid="is_trained_aiders_text" name="is_trained_aiders_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_trained_aiders_text" class="w-full" v-model="form.is_trained_aiders_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>


        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_quality_appraisal" name="is_quality_appraisal" rules="" v-slot="{ errors }">
              <small class="label">12.3 Would you agree to provide access for a representative of International Taste Solutions Ltd. to carry out a Quality Appraisal of your premises and systems? </small>
              <vs-switch v-model="form.is_quality_appraisal" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_quality_appraisal" vid="is_quality_appraisal_text" name="is_quality_appraisal_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_quality_appraisal_text" class="w-full" v-model="form.is_quality_appraisal_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>


        <div class="flex flex-wrap items-center justify-end" v-can="'edit-site'">
          <vs-button v-if="status.is_supplier_manufacture_site_health_safety_complete === 1"  button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4">Save and Change</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRepository = RepositoryFactory.get('supplier');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_health_policy:false,
          is_trained_aiders:false,
          is_quality_appraisal:false
        },
        id: null,
        status: {}
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_health_safety_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.UpdateManufactureHealthAndSafetyDetails(this.id, this.form))
          this.showSuccessMessage('Manufacture Health & Safety Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.CreateManufactureHealthAndSafetyDetails(this.form))
          this.showSuccessMessage('Manufacture Health & Safety Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureHealthAndSafetyDetails(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_health_safety_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
